import reportWebVitals from './reportWebVitals';
import './index.css';

// 过滤掉 :first-child 相关的 SSR 警告
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error;
  console.error = (...args) => {
    if (
      typeof args[0] === 'string' &&
      args[0].includes(':first-child') &&
      args[0].includes('potentially unsafe when doing server-side rendering')
    ) {
      return;
    }
    originalError.apply(console, args);
  };
}

async function bootstrap() {
  if (window.location.pathname === '/oss/login') {
    const { default: bootstrapOssLogin } = await import('./bootstrapOssLogin');
    await bootstrapOssLogin();
    return;
  }

  await import('./i18n');
  const { default: bootstrapApp } = await import('./bootstrapApp');
  bootstrapApp();
}

bootstrap();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
